module.exports = __webpack_public_path__ + "img/albin.6cb818b4.jpg";